import React from 'react';
import { createSlug } from '../../util/urlHelpers';
import css from './SectionSimilarListings.module.css';

const ListingCard = ({ listing, variantPrefix }) => {
  const { title = '', price, publicData = {} } = listing.attributes;
  const slug = createSlug(title);
  const href = `/l/${slug}/${listing.id.uuid}`;

  // Pick the best available image variant
  const images = listing.images || [];
  const firstImage = images[0];
  const variants = firstImage?.attributes?.variants || {};
  const imgUrl =
    variants[`${variantPrefix}-2x`]?.url ||
    variants[variantPrefix]?.url ||
    null;

  // Key meta facts
  const capacity = publicData.passenger_capacity;
  const length = publicData.boat_length;
  const metaParts = [
    length ? `${length} feet` : null,
    capacity ? `${capacity} guests` : null,
  ].filter(Boolean);
  const metaText = metaParts.length > 0 ? metaParts.join(' · ') : null;

  const priceAmount = price?.amount;
  const currency = price?.currency || 'USD';
  const unitType = publicData.unitType;
  const unitLabel =
    unitType === 'hour' ? '/ hr' :
    unitType === 'day' ? '/ day' :
    unitType === 'night' ? '/ night' :
    '/ hr';
  const formattedPrice =
    priceAmount != null
      ? new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: 0 }).format(
          priceAmount / 100
        ) + ` ${unitLabel}`
      : null;

  return (
    <a href={href} className={css.card}>
      <div className={css.imageWrapper}>
        {imgUrl ? (
          <img src={imgUrl} alt={title} className={css.image} />
        ) : (
          <div className={css.imagePlaceholder}>⛵</div>
        )}
      </div>
      <div className={css.cardBody}>
        <p className={css.cardTitle}>{title}</p>
        {metaText ? <p className={css.cardMeta}>{metaText}</p> : null}
        {formattedPrice ? <p className={css.cardPrice}>{formattedPrice}</p> : null}
      </div>
    </a>
  );
};

const SectionSimilarListings = ({ listings, variantPrefix = 'listing-card' }) => {
  if (!listings || listings.length === 0) return null;

  return (
    <section className={css.root}>
      <h2 className={css.heading}>More boats you might like</h2>
      <div className={css.carousel}>
        {listings.map(l => (
          <ListingCard key={l.id.uuid} listing={l} variantPrefix={variantPrefix} />
        ))}
      </div>
    </section>
  );
};

export default SectionSimilarListings;
